import { COMPANY_EMAIL } from './COMPANY_EMAIL';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Email addresses for contact form submissions</blockquote>
 * 
 * @remarks
 * Currently both employer and doctor contacts route to the same company email.
 * These can be updated to separate addresses when needed.
 * 
 * @example
 * ```typescript
 * import { CONTACT_EMAILS } from '@shared/constants';
 * 
 * const recipientEmail = formType === 'demo' 
 *   ? CONTACT_EMAILS.EMPLOYERS 
 *   : CONTACT_EMAILS.DOCTORS;
 * ```
 */
export const CONTACT_EMAILS = {
  EMPLOYERS: COMPANY_EMAIL,
  DOCTORS: COMPANY_EMAIL,
} as const;
